import { render } from "./NavLinks.vue?vue&type=template&id=5af16fa8&scoped=true"
import script from "./NavLinks.vue?vue&type=script&lang=js"
export * from "./NavLinks.vue?vue&type=script&lang=js"

import "./NavLinks.vue?vue&type=style&index=0&id=5af16fa8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af16fa8"]])

export default __exports__